import { transform as OlTransform } from 'ol/proj';
import { Coordinate } from 'ol/coordinate';

import { IGFICardOverlayData } from '@/@types/views/map';

// point features go to their own geometry (GFI returns it in 3857), everything else to the click
export const get3DTargetPosition = (featureData: IGFICardOverlayData): Coordinate => {
  const geometry = featureData.features?.[0]?.geometry;
  if (geometry?.type === 'Point') return geometry.coordinates as Coordinate;
  return featureData.position;
};

export const get3DUrl = (featureData: IGFICardOverlayData) => {
  const position = get3DTargetPosition(featureData);
  const [cx, cy] = OlTransform([position[0], position[1]], 'EPSG:3857', 'EPSG:4326').map((x) => (x * Math.PI) / 180);
  const cz = featureData.features?.[0]?.properties.cz ?? position[2] ?? 0;
  return `/3d?cx=${cx}&cy=${cy}&cz=${cz}`;
};
